module.exports = __webpack_public_path__ + "img/pliants.7b5b0d4.svg";